'use client';

import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@/components/IconComponent';
import { ImageComponent } from '@/components/Image';
import {
  ProgressBar,
  ValuePosition,
} from '@/components/progressBars/LinearProgressBar';
import { ProgressBarMode } from '@/components/progressBars/LinearProgressBar/styled';
import { EMissionStatus, useMissions } from '../../hooks/useMissions';
import { ScMissions } from './styled';

export const Missions = forwardRef<HTMLDivElement>((_props, ref) => {
  const { t } = useTranslation(['mission']);

  const { missions } = useMissions();

  return (
    <ScMissions ref={ref}>
      {missions.map((mission) => (
        <div
          className={`mission ${mission.status.toLowerCase()}`}
          data-character={mission.character}
          key={mission.character}
        >
          <div>
            <div className="img-container">
              <ImageComponent
                alt={`character${mission.character}`}
                height={168}
                src={
                  mission.status === EMissionStatus.LOCKED
                    ? mission.character === 0
                      ? '/mission/character-0.webp'
                      : '/mission/heart-locked.webp'
                    : mission.imgSrc
                }
                width={168}
              />
              <IconComponent className="tick-icon" name="tickIcon" />
            </div>
            {mission.character !== 0 &&
              mission.status === EMissionStatus.ACTIVE && (
                <ProgressBar
                  borderRadius="20px"
                  borderRadiusInner={
                    mission.progress.current === 100 ? '24px' : '24px 0 0 24px'
                  }
                  height={24}
                  mode={ProgressBarMode.PRIMARY_WHITE}
                  showTo={false}
                  showValue={ValuePosition.CENTER}
                  to={mission.progress.target}
                  value={mission.progress.current}
                  withUnits
                />
              )}
          </div>
          <div className="mission-stage-info">
            {mission.status === EMissionStatus.ACTIVE ? (
              <span className="status">{mission.prize}</span>
            ) : (
              <span className="status">
                {t(`mission:status.${mission.status.toLowerCase()}`)}
              </span>
            )}
            <span className="lvl">{mission.level}</span>
          </div>
        </div>
      ))}
    </ScMissions>
  );
});

Missions.displayName = 'Missions';
